/* lua.js generated code 0.3.0 */

var BottomButtonAnim = require("clover/panel/component/common/uiButtonAnims/HomeSceneBottomBtnAnim")
var MarketButton = xClass("MarketButton", HomeSceneButton)

MarketButton.prototype.ctor = function () {
    let self = this
    let str = getText("shopname.in.buyban")
    // var str = getText("shopname.out.buyban")
    // if (isPlatformIOS()) {
    // }
    if (window.qq && cc.sys.os === cc.sys.OS_ANDROID) {
        HomeSceneButton.prototype.ctor.call(self, cc.LabelTTF.create(str, FONT_DEF.microsoftYahei_24_whiteStroke), "homeicon/lobby_icon_shop.png", true, true, PromptTypeDef.newTip)
    } else {
        HomeSceneButton.prototype.ctor.call(self, str, "homeicon/lobby_icon_shop.png", true, true, PromptTypeDef.newTip)
    }
    self.mgr = MarketManager.getInstance()
    self.bg.setOpacity(255 * 0.7)

    self.free_tips = cc.Sprite.createWithSpriteFrameName("commonLib/free_tips.png")
    self.addChild(self.free_tips)
    self.free_tips.setPosition(35,35)

    self.updateUI()
    // self.prompt.setVisible(true)
    // self.setPromptNum("！")
    self.mgr.dcMarketNormal("icon_show")

    self._kWelfareCenterClick = function (event) {
        if (event.data.id == WelfareCenterId.freeCoin) {
            console.log("福利中心  banner点击：" + JSON.stringify(event.data));
            self.onCick(event,"welfare_center")
        }
    }
    GlobalEventDispatcher.getInstance().addEventListener(
        kGlobalEvents.kWelfareCenterClick,
        self._kWelfareCenterClick,
    )

}
MarketButton.prototype.customInit = function () {
    let self = this
    cc.log("market customInit")
}
// MarketButton.prototype.init = function () {
//     var self = this
//     self.csNode = cc.CSLoader.createNode("cocos/homeScene_icon_shop.csb")
//     self.addChild(self.csNode)
//     var btn = UIButton.create(self.csNode, true)
//     btn.on(UIButtonEvent.Click, handler(self, self.onOpenMarket))
//     self.btn = btn
//     self.posIndex = 4
//     self.isBusy = false
//     self.csNode.getChildByName("txt2").setVisible(false)
//     var label = self.csNode.getChildByName("txt")
//     label.setScale(label.getScale() * 0.9)
//     let bg = self.csNode.getChildByName("bg")
//     label.setPosition(label.getPositionX() + 2, label.getPositionY() - 7)
//     bg.setScale(1)
//     bg.setOpacity(255 * 0.7)
//     self.csNode.getChildByName("icon").setPosition(12, 7)

//     let size = bg.getContentSize()
//     var str  = '商店'
//     if(isPlatformIOS()) {
//         str = '道具屋'
//     }
//     let newText = cc.LabelTTF.create(str, FONT_DEF.microsoftYahei_24_blueStroke)
//     // newText.setScale(0.83)
//     newText.x = - 5
//     newText.y = - size.height / 2 - 8
//     label.removeFromParent(true)

//     self.csNode.addChild(newText, 2, "txt")
//     var icon = self.csNode.getChildByName("icon")
//     icon.setPositionY(icon.getPositionY() - 3)
//     BottomButtonAnim.create(self.btn)

// }
MarketButton.prototype.onOpenMarket = function (event,enterType) {
    let self = this
    if (self.isBusy) {
        return
    }

    DCAssist.dc4ClickIcon("shop", "click_icon",{session:`${UserManager.getInstance().uid}_${Localhost.timeInSec()}`})

    self.isBusy = true
    function onFail() {
        MarketManager.getInstance().clearCashGoodsEntry();
        Toast.make(getText("error.tip.timeout"))
        self.isBusy = false
    }
    function onSuccess(panel) {
        panel.on(BasePanelEvent.Close, () => MarketManager.getInstance().clearCashGoodsEntry())
        self.isBusy = false
    }
    // preloadWithLoading(preload_list, function () {
    //     var tabId = MarketPanelTabId.kCashTab
    //     MarketPanel.show(tabId)
    //     self.isBusy = false
    // }, onFail, onCancel)
    
    MarketManager.getInstance().setCashGoodsEntry(MarketManager.CashGoodsEntry.ClickMarketBtnInHome);
    var tabIdKey = enterType ? MarketPanelTabKey.kCashTab : null
    enterType = enterType ? enterType : "icon"
    MarketManager.getInstance().showMarketPanel(tabIdKey, onSuccess, onFail,enterType)
}
MarketButton.prototype.onCick = MarketButton.prototype.onOpenMarket
// MarketButton.create = function () {
//     var self = this
//     var instance = MarketButton.new()
//     assert(instance)
//     if (instance) {
//         instance.init()
//     }
//     return instance
// }
MarketButton.prototype.updateUI = function () {
    let self = this
    self.free_tips.setVisible(false)
    self.prompt &&self.prompt.setVisible(false)

    if (MarketManager) {
        let mgr = MarketManager.getInstance()
        if (mgr.isFirstShow()){
            self.setPromptType(PromptTypeDef.newTip);
        }else if (mgr.isHaveAd()){
            self.free_tips.setVisible(true)
        }
    }

    // if (MarketManager && MarketManager.getInstance().isHaveAd()){
    //     self.free_tips.setVisible(true)
    // }else{
    //     self.free_tips.setVisible(false)
    // }

    //
    if (MarketManager.getInstance().isUseNewStrategy() && MarketManager.getInstance().isOpenGetCashAd()) {
        const Event = require("hecore/EventDispatcher").Event;
        GlobalEventDispatcher.getInstance().dispatchEvent(Event.new(kGlobalEvents.kWelfareCenterAction,
            {
                id: WelfareCenterId.freeCoin,
                // redDot: isFree,
            }))
    }
}
module.exports = MarketButton
